import React from 'react';
import { sendError } from '../../sentry';
import { invokeWebviewDeeplink } from '../../utils/invokeWebAction';
import { notifyParent } from '../../utils/notifyIframe';
import { NewCriticalErrorOverlay } from '../NewCriticalErrorOverlay';

interface ErrorBoundaryProps {
  children: JSX.Element;
  isWebview: boolean;
}

interface State {
  error?: Error;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  static getDerivedStateFromError(unknownError: unknown): State {
    const error = unknownError instanceof Error ? unknownError : new Error('Unknown error');
    notifyParent({
      type: 'survey_iframe_readystatechange',
      state: 'cancelled',
      reason: 'UNKNOWN_ERROR',
    });
    sendError(error, { severity: 'CRITICAL' });
    return { error };
  }

  override state: State = {};

  override render(): JSX.Element {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <NewCriticalErrorOverlay
        isWebview={this.props.isWebview}
        onClose={() => invokeWebviewDeeplink('location', { method: 'close' })}
      />
    );
  }
}
